function Montserrat({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1689)">
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z" fill="#0052B4"/>
  <path d="M15.9572 15.9998H16C16 15.9855 16 15.9715 16 15.957C15.9857 15.9713 15.9715 15.9856 15.9572 15.9998Z" fill="#F0F0F0"/>
  <path d="M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z" fill="#F0F0F0"/>
  <path d="M8.09467 2.08691C5.59223 3.51185 3.51179 5.59223 2.08691 8.09467V16H6.26085V6.26098V6.26085H16C16 4.94442 16 3.69029 16 2.08691H8.09467Z" fill="#D80027"/>
  <path d="M16 14.0322L10.3153 8.34766H8.34778V8.34778L15.9998 15.9998H16C16 15.9998 16 14.6431 16 14.0322Z" fill="#D80027"/>
  <path d="M18.0869 8.34766V15.9998C18.0869 19.7273 22.9565 20.8694 22.9565 20.8694C22.9565 20.8694 27.826 19.7273 27.826 15.9998V8.34766H18.0869Z" fill="#338AF3"/>
  <path d="M18.0869 16C18.0869 19.7275 22.9565 20.8696 22.9565 20.8696C22.9565 20.8696 27.826 19.7275 27.826 16H18.0869Z" fill="#A2001D"/>
  <path d="M25.0434 11.8259H23.6521V10.4346H22.2608V11.8259H20.8695V13.2172H22.2608V17.3911H23.6521V13.2172H25.0434V11.8259Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Montserrat;
